export default "__VITE_ASSET__Cvwltxfb__"